import { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useSearchParams, } from 'react-router-dom';


class UserData {
    lang = '';
    user_id = '';
    role = '';
    isFarmer = '';
    platform = '';
    version = '';
    v_code = '';
    region = '';
    linkVersion = '';
    app_gateway_api_key = '';
    authorization = '';
    payment_id = '';
    session_id = '';
    funnel = '';
    source_page = '';
    first_name = '';
    last_name = '';
    mobile = '';
    name = '';
}

export const AuthContext = createContext({
    analytics: null,
    trackEvent: null,
    userData: null,
});

const AuthContextProvider = ({children}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [userData, setUserData] = useState();
    const [analytics, setAnalytics] = useState();
    const [sourcePage, setSourcePage] = useState(null);

    useEffect(()=>{
        const queryParams = new UserData();
        searchParams.forEach((value, key) => {
            if (key === 'is-farmer') {
                queryParams.isFarmer = value;
            } else if (key === 'name') {
                const [first_name, last_name] = (value || '').split(/\s+(.*)/);
                queryParams.name = value;
                queryParams.first_name = first_name;
                queryParams.last_name = last_name;
            } else {
                queryParams[key] = value;
            }
        });
        setUserData(queryParams);
        setSourcePage(queryParams.source_page);

        const initialize = async () => {
            const [[analyticsResp], configResp] = await Promise.all([
                AnalyticsBrowser.load({ writeKey: process.env.REACT_APP_SEGMENT_KEY })
            ]);
            setAnalytics(analyticsResp);
            analyticsResp.identify(queryParams.user_id, {
                /* MoEngage Standard Attributes */
                firstName: queryParams.first_name,
                lastName: queryParams.last_name,
                phone: '91' + queryParams.mobile,
                id: queryParams.user_id,
                name: queryParams.name,
                /* Additional Attributes*/
                Language: queryParams.lang,
                Role: queryParams.role,
                userId: queryParams.user_id,
            });
        }

        try {
            initialize();
        } catch (e) {
            console.error(e);
        }
        setSearchParams('', { replace: true });
    
    }, [])

    const trackEvent = useCallback((eventName, attributes, newSourcePage) => {
        if (newSourcePage) {
            setSourcePage(newSourcePage);
        }
        return analytics?.track(eventName, {
            funnel: userData?.funnel,
            session_id: userData?.session_id,
            user_id: userData?.user_id,
            user_profile: userData?.role,
            app_version: userData?.version,
            sourcePage: sourcePage,
            landingPage: newSourcePage,
            ...attributes,
        });
    }, [userData, analytics]);

    const value= {
        analytics,
        trackEvent,
        userData: userData,
    };

    return (
        <AuthContext.Provider value={value} >
            {(userData && analytics) ? children : ''}
        </AuthContext.Provider>
    );
}

export const useAuthContext = () => {
    return useContext(AuthContext);
}

export default AuthContextProvider;